import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { CronFormComponent } from '../../cron-form/cron-form.component';
import { ColDef, GridReadyEvent, RowClickedEvent, RowNode } from '@ag-grid-community/core';
import { FormServices } from 'src/app/services/form.services';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DialogService } from 'src/app/services/dialog.service';
import { PermissionServices } from 'src/app/services/permission.services';
import { ItensPermission } from 'src/app/interfaces/RolePermission';
import { localePt } from "../../../../assets/locale.pt.js";
import { ThemeService } from 'src/app/services/theme.service';
import { LanguageServices } from 'src/app/services/LanguageServices';

@Component({
    selector: 'app-multiple-context',
    templateUrl: './multiple-context.component.html',
    styleUrls: ['./multiple-context.component.scss'],
    standalone: false
})
export class MultipleContextComponent implements OnInit {
  sub2: Subscription;
  servers: any;
  editMode = false;
  cfgcompany: any;
  idconf: any;
  gridApi: any;
  active:boolean = false;
  selectedNodes: any;
  canEdit: boolean = false;
  canInsert: boolean = false;
  canDelete: boolean = false;
  canView: boolean = false;
  
  

  constructor(@Inject(MAT_DIALOG_DATA) public data, 
      public dialogRef:MatDialogRef<any>,
      private fb:FormBuilder,
      private spinner:NgxSpinnerService,
      private http:HTTPService,
      private formServices:FormServices,
      private snackBar:SnackbarService,
      private dialogServices:DialogService,
      private permissionService:PermissionServices,
      public ThemeService:ThemeService,
      public ls:LanguageServices) { }


      displayedColumns:ColDef[] = [
        {
            headerName: "Cod. Contexto",
            field: "CODECOMPANY",
            flex:1,
            resizable:true
        },
        {
          headerName: "Nome do Contexto",
          field: "CODECOMPANY_NAME",
          flex:4,
          resizable:true
        },
        {
          headerName: "Ativo",
          field: "ACTIVE",
          flex:2,
          resizable:true,
          valueFormatter: (param)=>{
            return  this.getDesc(param.value,'ACTIVE');
          },
          cellRenderer: (params)=> {
              if (params.value =='S'){
                return `<span class="active-chip">${params.valueFormatted}</span>`
              }else{
                return `<span class="inactive-chip">${params.valueFormatted}</span>`
              }
          }
        },
        {
          headerName:"Agendamento",
          field: 'SCHEDULE',
          resizable:true,
          flex:3,
        },
        {
          headerName:"Servidor",
          field: 'SERVERNAME',
          resizable:true,
          flex:3,
        },
      ]
        
  editForm:FormGroup<any>;
  serverName:string;
  cronComponent = CronFormComponent;

  refresh(){
    if ( this.canView ){
      this.loadContext();
    }else{
        this.gridApi.showNoRowsOverlay();
    }
      
  }

  ngOnInit(): void {

      let itemsPermission:ItensPermission =  this.permissionService.checkPermission('Mktpcfgcompany');
      this.canEdit = itemsPermission.canEdit;
      this.canInsert = itemsPermission.canInsert;
      this.canDelete = itemsPermission.canDelete;
      this.canView = itemsPermission.canView;
      
      this.idconf = this.data['IDCONF'];

      this.editForm = this.fb.group({
          CODECOMPANY: new FormControl(null, Validators.required),
          ACTIVE: new FormControl("N"),
          SCHEDULE: new FormControl(null, Validators.required),
          SERVERNAME: new FormControl(null, Validators.required),
      });

      if ( this.canView ){
        this.loadServers();
        this.loadContext();
      }
      
  }
  
  formSubmitted(result) {
    this.editForm.get("SCHEDULE").setValue(result);
  }

  ngOnDestroy(){
      if ( this.sub2 != null ){ this.sub2.unsubscribe()}
  }

  loadServers(){

      return new Promise((resolve,reject)=>{
        this.spinner.show('main-context');
        let ob = {
          entityName:"Mktpservers",
          sql:`SELECT 
                     *
                FROM MKTPSERVERS
                WHERE ISNULL(ACTIVE,'N')='S' `
        }
      
        this.sub2 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(async data=>{
            this.servers = data['SQL'];
            this.spinner.hide('main-context');
            resolve(true);
        },
        error=>{
            this.spinner.hide('main-context');
            throw error;
        });
      });
  }


  loadContext(){

    return new Promise((resolve,reject)=>{
      this.spinner.show('main-context');
      let ob = {
        entityName:"Mktpcfgcompany",
        sql:`SELECT 
                   A.CODECOMPANY,
                   B.NAME AS CODECOMPANY_NAME,
                   A.SCHEDULE,
                   A.ACTIVE,
                   A.SERVERNAME
              FROM MKTPCFGCOMPANY A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
              WHERE IDCONF=${this.idconf}`
      }
    
      this.sub2 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(async data=>{
          this.cfgcompany = data['SQL'];
          this.gridApi.applyTransaction({ add: this.cfgcompany });
          this.spinner.hide('main-context');
          resolve(true);
      },
      error=>{
          this.spinner.hide('main-context');
          throw error;
      });
    });
}

  add(){
      this.editForm.reset();
      this.editMode = true;
  }

  remove(){
    this.spinner.show('main-context');
    let cnt = this.selectedNodes.length;

    if (cnt == 0) {
      this.snackBar.showError("Nenhuma linha selecionada.");
      return;
    }

    try {
      this.dialogServices.title = "Exclusão de Dados";
      this.dialogServices.openNewDialog(
        "Excluir os itens selecionados?",
        () => {
          this.selectedNodes.forEach((rowNode: RowNode) => {
            let x = rowNode.data;
            let ob: Object = {};

            let remove: Object = {};
            let condition: string = `IDCONF=${this.idconf} AND CODECOMPANY=${rowNode.data.CODECOMPANY} `
            remove["entityName"] = 'Mktpcfgcompany';
            remove["condition"] = condition;

            this.http
              .post(remove, "JsonBrokerServices/remove", false)
              .subscribe(
                (x) => {
                  this.snackBar.showSuccess("Registro excluido com sucesso");
                  this.gridApi.applyTransaction({ remove: [rowNode.data] });
                  this.loadContext();
                  this.spinner.hide('main-context');
                },
                (error) => {
                  this.spinner.hide('main-context');
                  throw error;
                }
              );
          });
        },
        () => {
          this.spinner.hide('main-context');
        }
      );
    } catch (Exception) {
      throw Exception;
    }
  }

  save(){
      if ( this.editForm.invalid){
        this.snackBar.showError(this.formServices.getFormErrors(this.editForm,[
          {
            colName:"CODECOMPANY",
            colDesc:"Empresa"
          },
          {
            colName:"SCHEDULE",
            colDesc:"Agendador"
          },
          {
            colName:"SERVERNAME",
            colDesc:"Servidor"
          }
        ]));
        return;
      }
      this.saveDataCFGCompany();
  }

  async saveDataCFGCompany() {
    this.spinner.show('main-context');
    return new Promise((resolve, reject) => {

          let ob = {
              entityName:'Mktpcfgcompany',
              IDCONF:this.idconf,
              ...this.editForm.getRawValue(),
            }
            
  
            this.http.post(ob,'JsonBrokerServices/save',false,true,true).subscribe(data=>{      
              this.snackBar.showSuccess('Registro incluído/alterado com sucesso.');
              this.loadContext().then(d=>{
                this.editMode = false;
                this.spinner.hide('main-context');
                resolve(true);
              },
              error=>{
                this.spinner.hide('main-context');
                throw error;
              });    
            },
            error=>{
              this.spinner.hide('main-context');
              throw error;
            });
          });
      
  }


  cancel(){
    this.editMode = false;
  }

  getDesc(value:any, type){
    
    if ( value == null){
      return null;
    }
    if ( type=='ACTIVE'){
        if ( value == "S"){
            return 'Ativo';
        }else{
          return 'Inativo';
        }
    }
  }

  onGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;    
    if ( !this.canView){
      this.gridApi.showNoRowsOverlay();
    }
  }

  selectRow(row){
    if ( this.canEdit) {
      this.editForm.reset();
      this.formServices.refreshFormObject(this.editForm,row.data);
      this.active = row.data.ACTIVE=='S'?true:false;
      this.editMode = true;
    }else{
      this.snackBar.showError("Usuário não possui permissão para edição.");
    }
    
  }

  onToggleChange(column){

    if ( column=='ACTIVE'){
      if ( this.active ){
        this.editForm.get(column).setValue("S");
      }else{
        this.editForm.get(column).setValue("N");
      }      
    }
  }

  eventGridSelect(event: RowClickedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
  }
}
